import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { GeoEntity } from '@/utils/geo-search'
import isEqual from 'lodash/isEqual'

type ModuleStore = {
  localities: GeoEntity[],
  tb?: string[],
  pmax?: string | number,
  radiusValue?: number | 'all',
  setData: (data: Partial<ModuleStore>) => void
}

export const useSearchModuleStore = create<ModuleStore>()(
  persist(
    (set) => ({
      localities: [],
      radiusValue: 5000,
      setData: (data) => set((state) => {
        const newState = ({ ...state, ...data})
        return isEqual(state, newState) ? state : newState
      })
    }),
    {
      name: 'search-module', // name of the item in the storage (must be unique)
      skipHydration: true
    },
  )
)